export default "__VITE_ASSET__B$YQt3YX__"